import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";

/**
 * Renders a drop down button with child buttons for logging in with a popup or redirect
 */
export const SignInButton = () => {
    const { instance } = useMsal();

    const handleLogin = (loginType) => {
        if (loginType === "popup") {
            instance.loginPopup(loginRequest)
            .then((loginResponse) => {
                const idToken = loginResponse.idToken;
                const decodedIdToken = decodeJwt(idToken);
                console.log("ID Token:", JSON.stringify(decodedIdToken, null, 2));
        
                // Decode and log the Access Token
                const accessToken = loginResponse.accessToken;
                const decodedAccessToken = decodeJwt(accessToken);
                console.log("Access Token:", JSON.stringify(decodedAccessToken, null, 2));
        
                console.log("Account Info:", loginResponse.account);
            })
            .catch(e => {
                console.log(e);
            });
        } else if (loginType === "redirect") {
            instance.loginRedirect(loginRequest).catch(e => {
                console.log(e);
            });
        }
    }

    const decodeJwt = (token) => {
        const [header, payload, signature] = token.split('.');
        
        // Decode the base64url header and payload
        const decodedHeader = JSON.parse(atob(header.replace(/-/g, '+').replace(/_/g, '/')));
        const decodedPayload = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
        
        return {
            header: decodedHeader,
            payload: decodedPayload,
            signature: signature // Signature is not typically decoded for inspection
        };
    }

    return (
        <DropdownButton variant="secondary" className="ml-auto" drop="start" title="Sign In">
            <Dropdown.Item as="button" onClick={() => handleLogin("popup")}>Sign in using Popup</Dropdown.Item>
            <Dropdown.Item as="button" onClick={() => handleLogin("redirect")}>Sign in using Redirect</Dropdown.Item>
        </DropdownButton>
    )
}
